import React, { useMemo, useState } from "react";
import moment from "moment";

import { VaciadosCell } from "../../../components/VaciadosCell";
import NullableValue from "../../../../../Utils/renderField/nullableValue";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../Utils/renderField/renderReadField";
import { buildResumenMateriaPrima } from "../../../helpers/groupProductos";
import { DatosTraslado } from "./DatosTraslado";
const pesaIcon = require("assets/img/icons/pesa.png");
const borrarIcon = require("assets/img/icons/borrar.png");
const editarIcon = require("assets/img/icons/editar.png");

export const RecepcionesSeleccionadas = ({
    trasladoDetalle,
    recepcionesSeleccionadas,
    setMateriaPrimaSeleccionada,
    regresar,
    DarSalidaTraslado,
    MostrarMensajeEliminacionMateriaPrima,
    navigateToRecepciones,
}) => {
    const [modoResumen, setModoResumen] = useState(true);
    const [observaciones, setObservaciones] = useState("");

    const resumenRecepciones = useMemo(() => {
        return buildResumenMateriaPrima(
            recepcionesSeleccionadas,
            trasladoDetalle,
        );
    }, [recepcionesSeleccionadas, trasladoDetalle]);

    const FilaTotales = (
        <tr className="modal-ingresos__totales-row">
            <td
                className="text-right text-nowrap"
                colSpan={modoResumen ? 3 : 4}
            >
                <strong>TOTALES:</strong>
            </td>
            <td className="text-center text-nowrap">
                {/* TOTAL DE KG HÚMEDOS */}
                <RenderKilogramo
                    value={recepcionesSeleccionadas.reduce(
                        (total, detalle) =>
                            total + (detalle.kilos_humedos || 0),
                        0,
                    )}
                    decimalScale={2}
                />
            </td>
            {!modoResumen && <td></td>}
            <td className="text-center text-nowrap">
                {/* TOTAL DE KG SECOS */}
                <RenderKilogramo
                    value={recepcionesSeleccionadas.reduce(
                        (total, detalle) =>
                            total + (detalle.kilos_secos_laboratorio || 0),
                        0,
                    )}
                    decimalScale={3}
                />
            </td>
            {modoResumen && (
                <React.Fragment>
                    <td className="text-center text-nowrap cell-border-left">
                        {/* TOTAL DE PESOS REALES */}
                        <RenderKilogramo
                            value={resumenRecepciones.reduce(
                                (total, detalle) =>
                                    total +
                                    ((detalle.pesaje &&
                                        detalle.pesaje.peso_neto) ||
                                        0),
                                0,
                            )}
                            decimalScale={3}
                        />
                    </td>
                    <td></td>
                </React.Fragment>
            )}
        </tr>
    );

    const TablaDetalle = (
        <div className="new-table-wrapper pesaje-traslado__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>ID RECEPCIÓN</th>
                        <th>FECHA DE RECEPCIÓN</th>
                        <th>MATERIA PRIMA</th>
                        <th>ALMACENES</th>
                        <th>KILOS HÚMEDOS</th>
                        <th>DRC LABORATORIO</th>
                        <th>KILOS SECOS LAB</th>
                    </tr>
                </thead>
                <tbody>
                    {recepcionesSeleccionadas.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td className="text-center">
                                    {item.id_ingreso}
                                </td>
                                <td className="text-center text-nowrap">
                                    {moment(item.fecha_entrada).format(
                                        "DD/MM/YYYY HH:mm:ss",
                                    )}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.materia_prima
                                        ? item.materia_prima.nombre
                                        : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    <VaciadosCell productos={item.productos} />
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={item.kilos_humedos}>
                                        <RenderKilogramo
                                            value={item.kilos_humedos}
                                            decimalScale={2}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={item.drc_laboratorio}>
                                        <RenderNumberPercentage
                                            value={item.drc_laboratorio}
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.kilos_secos_laboratorio}
                                    >
                                        <RenderKilogramo
                                            value={item.kilos_secos_laboratorio}
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>
                            </tr>
                        );
                    })}
                    {FilaTotales}
                </tbody>
            </table>
        </div>
    );

    const TablaResumen = (
        <React.Fragment>
            <div className="new-table-wrapper recepcion-traslado__table-wrapper">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th>ACCIONES</th>
                            <th>RECEPCIONES</th>
                            <th>MATERIA PRIMA</th>
                            <th>KILOS HÚMEDOS</th>
                            <th>KILOS SECOS LAB</th>
                            <th className="cell-border-left">PESO NETO REAL</th>
                            <th>PESO BRUTO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {resumenRecepciones.map((item) => {
                            const materiaPrima = item.materia_prima || {};

                            return (
                                <tr key={item.id}>
                                    <td className="text-center">
                                        {item.yaPesado ? (
                                            "—"
                                        ) : (
                                            <div className="table-actions">
                                                <img
                                                    src={borrarIcon}
                                                    alt="Eliminar materia prima"
                                                    className="action_img"
                                                    title="Eliminar materia prima"
                                                    onClick={() =>
                                                        MostrarMensajeEliminacionMateriaPrima(
                                                            materiaPrima.id,
                                                        )
                                                    }
                                                />

                                                <img
                                                    src={pesaIcon}
                                                    alt="Pesar materia prima"
                                                    className="action_img"
                                                    title="Pesar materia prima"
                                                    onClick={() =>
                                                        setMateriaPrimaSeleccionada(
                                                            item,
                                                        )
                                                    }
                                                />

                                                <img
                                                    src={editarIcon}
                                                    alt="Editar recepciones"
                                                    className="action_img"
                                                    title="Editar recepciones"
                                                    onClick={() =>
                                                        navigateToRecepciones(
                                                            materiaPrima.id,
                                                        )
                                                    }
                                                />
                                            </div>
                                        )}
                                    </td>
                                    <td className="text-center text-nowrap pesaje-traslado__table-ellipsis-cell">
                                        {item.ingresos_ids_concat}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.materia_prima
                                            ? item.materia_prima.nombre
                                            : ""}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <NullableValue
                                            value={item.kilos_humedos}
                                        >
                                            <RenderKilogramo
                                                value={item.kilos_humedos}
                                                decimalScale={2}
                                            />
                                        </NullableValue>
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <NullableValue
                                            value={item.kilos_secos_laboratorio}
                                        >
                                            <RenderKilogramo
                                                value={
                                                    item.kilos_secos_laboratorio
                                                }
                                                decimalScale={3}
                                            />
                                        </NullableValue>
                                    </td>
                                    <td className="text-center text-nowrap cell-border-left">
                                        {item.yaPesado ? (
                                            <RenderKilogramo
                                                value={item.pesaje.peso_neto}
                                            />
                                        ) : (
                                            "—"
                                        )}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.yaPesado ? (
                                            <RenderKilogramo
                                                value={item.pesaje.peso_final}
                                            />
                                        ) : (
                                            "—"
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                        {FilaTotales}
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-end mt-3">
                <button
                    className="btn btn-secondary"
                    onClick={() => navigateToRecepciones()}
                >
                    Agregar materia prima
                </button>
            </div>
        </React.Fragment>
    );

    const hayPesosPendientes =
        resumenRecepciones.some((item) => !item.yaPesado) ||
        resumenRecepciones.length === 0;

    return (
        <React.Fragment>
            <DatosTraslado
                trasladoDetalle={trasladoDetalle}
                recepcionesSeleccionadas={recepcionesSeleccionadas}
            />

            {/* Recepciones */}
            <div className="d-flex justify-content-between mb-2">
                <h6>Recepciones</h6>
                <span
                    className="btn-link-pointer"
                    onClick={() => setModoResumen(!modoResumen)}
                >
                    {modoResumen ? "Mostrar detalle" : "Mostrar resumen"}
                </span>
            </div>
            {modoResumen ? TablaResumen : TablaDetalle}

            {/* TEXTAREA DE OBSERVACIONES */}
            {!hayPesosPendientes && (
                <div className="form-group mt-4">
                    <h6>Observaciones</h6>
                    <textarea
                        id="observaciones"
                        className="form-control"
                        rows={3}
                        value={observaciones}
                        onChange={(e) => setObservaciones(e.target.value)}
                    />
                </div>
            )}

            <div className="d-flex flex-wrap justify-content-center my-4 gap-2rem">
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>
                <button
                    className="btn btn-primary"
                    onClick={() => DarSalidaTraslado(observaciones)}
                    disabled={hayPesosPendientes}
                >
                    Enviar traslado a planta
                </button>
            </div>
        </React.Fragment>
    );
};
